import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, SimpleChanges, OnChanges} from '@angular/core';
import {Listing} from '../../../classes/listing';
import {TranslateService} from '@ngx-translate/core';
import {PreferencesService} from '../../../services/preferences.service';
import {CommunicationService} from '../../../services/communication.service';
import {HasSubscriptions} from '../../../components/has-subscriptions';
import {SCREEN_SIZE} from '../../../classes/enums';
import {caraBoardPartialName, victoriaRealEstate} from '../../../app-config.constants';
import { CacheService } from '../../../services/cache.service';
import { ListingsService } from '../../../services/listings.service';
import { ADD_SAVED_LISTING_PREVIEW_GTM, ADD_SAVED_LANDING_PAGE_GTM } from '../../../classes/analytics-tags';
import { Router } from '@angular/router';

@Component({
  selector: 'app-listing-card',
  templateUrl: './listing-card.component.html',
  styleUrls: [
    './listing-card.component.scss',
    './listing-card.desktop.component.scss',
    './listing-card.mobile.component.scss'
  ]
})
export class ListingCardComponent extends HasSubscriptions implements OnInit, OnChanges {
  @Input() showMap: boolean; // Whether or not to show the map, mainly used for LDP mobile
  @Input() listing: Listing;
  @Input() confirmUnfavourite: boolean = false;
  @Input() currentSlideIndex: number = 0; // Which image they're on in the image carousel
  @Input() isSelectedCard: boolean = false;
  @Input() isNextCard: boolean = false;
  @Input() includeAddress: boolean = true;
  @Input() isListingDetails: boolean = false; //  the card is used in multiple places, using the listing.isLuxury would change the design across all those places
  @Input() isLandingPageListing: boolean = false; // Whether or not its a listing on the landing page, we really only need this for Google Tag Manager
  @Input() isMapView: boolean = false; // checks whether or not rm-carousel should prefetch images
 
  @Output() unfavourited = new EventEmitter<void>();
  @Output() click = new EventEmitter<any>();
  @Output() onFocus = new EventEmitter<Event>();
  @Output() onHoverListingCard: EventEmitter<{action: string, listingId: string}> = new EventEmitter<{action: string, listingId: string}>();
  @Output() changeCarouselIndex: EventEmitter<number> = new EventEmitter();

  @ViewChild('card') card: ElementRef;
  showShare: boolean = false;
  highlight: boolean = false;
  priceOrPricePerSqFt: string;
  screenSize: number;
  isVictoriaRealEstateBoard: boolean = false;
  isCaraBoard: boolean = false;


  constructor(
    private _preferencesService: PreferencesService,
    private _listingService: ListingsService,
    private _router: Router,
    private communicationService: CommunicationService,
    private cache: CacheService,
    private translate: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    this.isVictoriaRealEstateBoard = this.listing.boardName && this.listing.boardName.toLowerCase().indexOf(victoriaRealEstate) !== -1 && !this.listing.isRemaxListing;
    this.isCaraBoard = this.listing.boardName && this.listing.boardName.toLowerCase().indexOf(caraBoardPartialName) !== -1 ;//&& !this.listing.isRemaxListing;

    this.setPriceOrPricePerSqFt();

    this.addSub(this.communicationService.screenSize.subscribe((screenSize) => this.screenSize = screenSize));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.listing) {
      this.setPriceOrPricePerSqFt();
    }
  }

  setPriceOrPricePerSqFt() {
    this.addSub(this._listingService.getPriceOrPricePerSqFtString(this.listing).subscribe(str => this.priceOrPricePerSqFt = str));
  }

  listingCardClicked(navigate?: boolean) {
    // Save the listingId for later so when we come back to the map we can open the carousel and show the listing.
    this.cache.set(this.cache.KeySelectedListingId, this.listing.listingId, 300, true);
    this.click.emit(this.listing.listingId);
    // TODO: Check this, clicking on the image listing does a URL change outside of angular
    if (navigate) {
      this._router.navigate([this.listing.detailUrl]);
    }
  }

  toggleFavourite($event) {
    $event.preventDefault();
    $event.stopPropagation();
    const confirmation = this.translate.instant('notification.confirm-remove-saved');
    if (this.confirmUnfavourite && this.listing.isFavourite && !confirm(confirmation)) return;

    this.listing.isFavourite = !this.listing.isFavourite;
    this._preferencesService.toggleFavouriteListing(this.listing.listingId, this.isLandingPageListing ? ADD_SAVED_LANDING_PAGE_GTM : ADD_SAVED_LISTING_PREVIEW_GTM);
    this.listing.getFavouriteIconToUse();
    if (!this.listing.isFavourite) {
      this.unfavourited.emit();
    }
  }

  showHideShare(event) {
    event.stopPropagation();
    this.showShare = !this.showShare;
  }

  setHighlight(listingId: string) {
    this.highlight = this.listing.listingId === listingId;
    if (this.highlight) {
      this.card.nativeElement.scrollIntoView(true);
    }
  }

  SCREEN_SIZE = SCREEN_SIZE;
}
